module.exports = __webpack_public_path__ + "public/SiteIcons/lightIcon.svg?977a42ed";